import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const ShortlistIcon = (props: SvgIconProps) => (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  <SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <rect x="2" y="10" width="18" height="2" fill="currentColor" />
    <rect x="2" y="6" width="18" height="2" fill="currentColor" />
    <rect x="2" y="14" width="18" height="2" fill="currentColor" />
    <rect x="2" y="18" width="10" height="2" fill="currentColor" />
    <rect x="19.332" y="24.6826" width="14" height="2" transform="rotate(-45 19.332 24.6826)" fill="currentColor" />
    <rect x="16.3438" y="18.9229" width="8.18552" height="2" transform="rotate(45 16.3438 18.9229)" fill="currentColor" />
  </SvgIcon>
)

export default ShortlistIcon
